import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import styles from './LinkButton.css';

const LinkButton = ({ children, to, className }) => (
  <Link
    to={to}
    className={classnames(className || styles.linkDefault, styles.linkCommon)}
  >
    <button className={styles.button}>{children}</button>
  </Link>
);

LinkButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
  to: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default LinkButton;



// WEBPACK FOOTER //
// ./src/components/LinkButton.jsx